import styled from "@emotion/styled";
import React, { useEffect, useMemo, useRef, useState } from "react";
import ico_arrow_down_white from "@src/assets/ico_arrow_down_white.png";

import deungi_search_info from "@src/assets/deungi/corp/corp_deungi_search_info.png";
import ico_list_search_black from "@src/assets/ico_list_search_black.png";
import lottie_loading from "@src/assets/lottie_loading_deungi.json";
import { CORP_DEUNGI_POPUP_TYPE, CORP_DEUNGI_FILTER_STATE } from "./common/enum";

import { CorpPopupDto, CorpSearchListDto } from "@src/hooks/deungi/dto/SearchList.dto";

import Lottie from "lottie-react";
import CorpDeungiPopup from "./CorpDeungiPopup";

import dayjs from "dayjs";
import noMoreImage from "@src/assets/goStop/noMore.png";
import { transferToNative, WebAppBridge } from "@src/lib/WebAppBridge";
import micIcon from "@src/assets/basicIcon/micIcon.svg";
import { debounce } from "lodash";
import { useCorpSearchList } from "@src/hooks/deungi/corp/useCorpSearchList";
import { usePrevCorpDeungi } from "@src/hooks/deungi/corp/usePrevCorpDeungi";
import DeungiCombo from "../deungi/DeungiCombo";
import { useNavigate } from "react-router-dom";

// end가 배열 길이보다 클 경우, 배열의 끝까지 자르기
function customSlice(arr: CorpSearchListDto[] | undefined, end: number, filter: string) {
    if (arr) {
        if (filter === "살아있는") arr = arr.filter((aa) => aa.deungiStatus === "살아있는 등기");
        else if (filter === "폐쇄") arr = arr.filter((aa) => aa.deungiStatus !== "살아있는 등기");
        end = end > arr.length ? arr.length : end;
        return arr.slice(0, end);
    } else return [];
}

const CorpDeungiSearchBox = () => {
    const navigate = useNavigate();
    const [openData, setOpenData] = useState({} as any);
    const [hasOpenData, setHasOpenData] = useState<CorpPopupDto>();
    const [popupType, setPopupType] = useState<CORP_DEUNGI_POPUP_TYPE>(CORP_DEUNGI_POPUP_TYPE.OPEN);
    const [popupToggle, setPopupToggle] = useState(false);
    const [filterStateToggle, setFilterStateToggle] = useState(false);
    const [filterState, setFilterState] = useState(CORP_DEUNGI_FILTER_STATE.ALL as CORP_DEUNGI_FILTER_STATE);
    const [isSearchDone, setIsSearchDone] = useState(false);

    const [searchText, setSearchText] = useState("");

    const { data: searchAddressData, refetch, isFetching: isFetchingSearchAddress } = useCorpSearchList(searchText);

    useEffect(() => {
        if (searchText !== "" && isSearchDone) refetch();
    }, [isSearchDone, filterState]);

    const searchInputRef = useRef() as any;

    WebAppBridge.setSpeechResult = async (val: string) => {
        setSearchText(val);
    };

    const onOpenHandler = async (deungiInfo: CorpSearchListDto) => {
        if (!deungiInfo) return;

        setOpenData(deungiInfo);

        const res = await usePrevCorpDeungi(deungiInfo);
        const prevDeungiInfo = res.data;
        if (prevDeungiInfo.exist) {
            setHasOpenData(prevDeungiInfo);
            setPopupType(CORP_DEUNGI_POPUP_TYPE.HAS_DEUNGI);
        } else {
            setPopupType(CORP_DEUNGI_POPUP_TYPE.OPEN);
            localStorage.setItem("corpSearchText", searchText);
        }
        setPopupToggle(true);
    };

    const onSearchTextHandler = (e: any) => {
        isSearchDone && setIsSearchDone(false);
        setSearchText(e?.target?.value);
    };

    function enterHandler(e: React.KeyboardEvent<HTMLInputElement>) {
        if (e.key === "Enter") {
            setIsSearchDone(true);
        }
    }

    const addressList = customSlice(searchAddressData, 1000, filterState)?.map((aa) => {
        let str = aa.deungiStatus;
        str = str.replace(" ", "\n");
        return (
            <tr key={`${aa.corporationName}_${aa.registCode}`} onClick={() => onOpenHandler(aa)}>
                <td>{aa.corporationName}</td>
                <td>{str}</td>
                <td>{<span>열람</span>}</td>
            </tr>
        );
    });

    useEffect(() => {
        const selectedCorpState = localStorage.getItem("selectedCorpState");
        if (selectedCorpState) {
            setOpenData(JSON.parse(selectedCorpState).corp);
        }
    }, []);

    return (
        <>
            <DeungiFilter>
                <div onClick={() => setFilterStateToggle(true)}>
                    <label>폐쇄여부</label>
                    <OptionBox>{filterState}</OptionBox>
                </div>
            </DeungiFilter>
            <DeungiSearchBar>
                <div className="searchBox">
                    <input
                        ref={searchInputRef}
                        type="text"
                        placeholder="주소 또는 건물명 입력"
                        onChange={onSearchTextHandler}
                        onKeyDown={enterHandler}
                        value={searchText}
                        autoFocus={!!searchText}
                    />
                    <div className="searchSubmitBox" onClick={() => {}}>
                        <img src={ico_list_search_black} />
                    </div>
                    {navigator.userAgent.toLowerCase().includes("iphone") && (
                        <div
                            className="searchMicBox"
                            onClick={(evt) => {
                                evt.stopPropagation();
                                transferToNative("webSearch", "onClickSearchMic");
                            }}
                        >
                            <img src={micIcon} />
                        </div>
                    )}
                </div>
            </DeungiSearchBar>
            {!isSearchDone ? (
                <DeungiSearchInfo>
                    <img src={deungi_search_info} />
                </DeungiSearchInfo>
            ) : (
                <DeungiSearchList>
                    {isFetchingSearchAddress ? (
                        <div className="loadingBox">
                            <Lottie className="lottie" animationData={lottie_loading} />
                        </div>
                    ) : (
                        <>
                            {customSlice(searchAddressData, 9999, filterState).length > 0 ? (
                                <>
                                    <div className="topLabel">
                                        총 <span>{customSlice(searchAddressData, 9999, filterState).length}</span>건의 등기정보가
                                        있습니다.
                                    </div>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>등기 상호명</th>
                                                <th>폐쇄여부</th>
                                                {<th>열람신청</th>}
                                            </tr>
                                        </thead>
                                        <tbody>{addressList}</tbody>
                                    </table>
                                </>
                            ) : (
                                <div className={"notFoundInfo"}>
                                    <img src={noMoreImage} alt="no_more_icon" className="noMore" width={50} height={60} />
                                    <div>
                                        해당 상호명의 법인 등기 정보가 존재하지 않습니다. <br />
                                        검색어를 다시 확인해주세요
                                        <br />
                                        <br />※ 법인 등기는 등기 상호명으로만 검색이
                                        <br />
                                        가능합니다. 정확한 상호명을 입력해주세요.
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </DeungiSearchList>
            )}
            <CorpDeungiPopup
                type={popupType}
                toggle={popupToggle}
                setToggle={setPopupToggle}
                data={openData}
                hasOpenData={hasOpenData}
                onClose={() => {
                    localStorage.removeItem("corpSearchText");
                }}
            />

            <DeungiCombo
                option={filterState}
                options={Object.values(CORP_DEUNGI_FILTER_STATE)}
                toggle={filterStateToggle}
                setOption={setFilterState}
                setToggle={setFilterStateToggle}
            />
        </>
    );
};

const DeungiSearchInfo = styled.div`
    width: 100%;
    height: calc(100dvh - 285px);
    overflow: scroll;

    & > img {
        width: 100%;
        animation: fadeIn 0.3s;
    }
    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

const DeungiSearchList = styled.div`
    width: 100%;
    height: calc(100dvh - 285px);
    overflow: hidden auto;
    display: flex;
    flex-direction: column;

    .topLabel {
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 13px;
        line-height: 1.4;
        padding: 0 14px;
        margin: 10px 0;

        & > span {
            color: #ff0000;
            margin-left: 3px;
        }
        & > img {
            width: 16px;
            height: 16px;
            margin-right: 3px;
        }
    }
    & > table {
        width: 100%;
        padding-bottom: 40px;
        table-layout: fixed;
        border-collapse: initial;
        font-size: 13px;

        & > thead {
            position: sticky;
            z-index: 2;
            top: 0;
        }

        & > thead > tr {
            background: #fbf8f8;
            color: #8d8d8d;

            & > th {
                word-break: keep-all;
                font-weight: 500;
                border: 10px solid #fbf8f8;
            }
            & > th:nth-of-type(1) {
                width: 50%;
            }
            & > th:nth-of-type(3) {
                width: 50px;
            }
            & > th:nth-of-type(2) {
                width: 65px;
            }
        }
        tbody {
            table-layout: fixed;
            width: 100%;
            overflow: auto;
            tr {
                width: 100%;
                color: #0c002c;
                animation: fadeIn 0.5s;

                :active {
                    background: #dff0ff;
                }
                & > td {
                    word-break: keep-all;
                    font-weight: 500;
                    line-height: 1.4;
                    vertical-align: middle;
                    text-align: center;
                    padding: 15px 3px;
                    border-bottom: 1px solid #dadada;
                }
                & > td:nth-of-type(1) {
                    text-align: left;
                    padding-left: 14px;
                    word-break: normal;
                }
                & > td:nth-of-type(3) > span {
                    background: #0047ff;
                    color: #fff;
                    padding: 8px;
                    border-radius: 24px;

                    &.alarm {
                        background: #ebfbfa;
                        color: #0c002c;
                    }
                }
            }
        }
    }

    .loadingBox {
        margin: 20px 0 80px;

        .lottie {
            width: 50px;
            margin: auto;
        }
    }

    .notFoundInfo {
        display: flex;
        gap: 20px;
        flex-wrap: wrap;
        justify-content: center;
        font-size: 14px;
        line-height: 1.8;
        text-align: center;
        padding-top: 120px;

        img {
            display: block;
        }

        div {
            width: 100%;
        }
        &:hover {
            background: #fff;
        }
    }
`;

const DeungiSearchBar = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 20px 0 0;
    padding: 0 14px 14px;

    &.isSearch {
        transition: all 0.3s ease;
        box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);
    }
    .searchLabel {
        width: 100px;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        & > img {
            width: 18px;
            height: 18px;
            margin-left: 5px;
        }
    }
    .searchBox {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;

        & > input {
            width: 100%;
            height: 40px;
            font-weight: 400;
            font-size: 14px;
            padding: 0 50px;
            background: #fbf8f8;
            border-radius: 24px;
            text-align: left;
            border: 0;

            &.hidden {
                padding: 0 15px;
            }
        }
        .searchSubmitBox {
            position: absolute;
            display: flex;
            left: 0;
            width: 50px;
            height: 50px;
            align-items: center;

            & > img {
                width: 24px;
                height: 24px;
                margin: auto;
                transition: all 0.2s;

                &.hidden {
                    opacity: 0;
                }
            }
        }
        .searchMicBox {
            display: flex;
            width: 50px;
            height: 50px;
            align-items: center;

            & > img {
                width: 24px;
                height: 24px;
                margin: auto;
                transition: all 0.2s;

                &.hidden {
                    opacity: 0;
                }
            }
        }
    }
`;

const DeungiFilter = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    padding: 0 14px;

    & > label {
        line-height: 50px;
        white-space: nowrap;
    }
    & > div {
        display: flex;
        align-items: center;
    }
`;

const OptionBox = ({ children }: any) => {
    const Container = styled.div`
        display: flex;
        justify-content: space-between;
        width: 220px;
        align-items: center;
        background: #2275ee;
        padding: 12px 8px;
        margin-left: 10px;
        border: 1px solid #2275ee;
        color: #fff;
        box-shadow: 2px 2px 6px rgba(4, 0, 14, 0.14);
        border-radius: 24px;

        & > div {
            width: 100%;
            text-align: center;
        }
        & > img {
            width: 11px;
            height: 7px;
        }
        @media screen and (max-width: 355px) {
            & {
                margin-left: 4px;
            }
        }
    `;

    return (
        <Container>
            <div>{children}</div>
            <img src={ico_arrow_down_white} />
        </Container>
    );
};

export default CorpDeungiSearchBox;
